export default __webpack_public_path__ + "static/media/header.02c2e773.png";